import './css/styles.css';

import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';

import { getImagesByQuery } from './js/pixabay-api';
import {
    createGallery,
    clearGallery,
    showLoader,
    hideLoader,
    showLoadMoreButton,
    hideLoadMoreButton,
    } from './js/render-functions';

    const form = document.querySelector('.form');
    const input = document.querySelector('.form-input');
    const loadMoreBtn = document.querySelector('.load-more');

    let query = '';
    let page = 1;
    let totalPages = 0;

    form.addEventListener('submit', onSearch);
    loadMoreBtn.addEventListener('click', onLoadMore);

    async function onSearch(e) {
    e.preventDefault();

    query = input.value.trim();
    if (!query) {
        iziToast.warning({ message: 'Please enter a search query', position: 'topRight' });
        return;
    }

    page = 1;
    totalPages = 0;

    clearGallery();
    hideLoadMoreButton();
    showLoader();

    try {
        const data = await getImagesByQuery(query, page);

        if (!data.hits.length) {
        iziToast.info({
            message: 'Sorry, there are no images matching your search query. Please try again!',
            position: 'topRight',
        });
        return;
        }

        createGallery(data.hits);

        totalPages = Math.ceil(data.totalHits / 15);

        if (page < totalPages) {
        showLoadMoreButton();
        } else {
        hideLoadMoreButton();
        iziToast.info({
            message: "We're sorry, but you've reached the end of search results.",
            position: 'topRight',
        });
        }
    } catch {
        iziToast.error({ message: 'Something went wrong. Please try again later.', position: 'topRight' });
    } finally {
        hideLoader();
    }
    }

    async function onLoadMore() {
    page += 1;

    showLoader();
    hideLoadMoreButton();

    try {
        const data = await getImagesByQuery(query, page);
        createGallery(data.hits);

        smoothScroll();

        if (page < totalPages) {
        showLoadMoreButton();
        } else {
        hideLoadMoreButton();
        iziToast.info({
            message: "We're sorry, but you've reached the end of search results.",
            position: 'topRight',
        });
        }
    } catch {
        iziToast.error({ message: 'Something went wrong. Please try again later.', position: 'topRight' });
    } finally {
        hideLoader();
    }
    }

    function smoothScroll() {
    const firstCard = document.querySelector('.gallery-item');
    if (!firstCard) return;

    const { height } = firstCard.getBoundingClientRect();

    window.scrollBy({
        top: height * 2,
        behavior: 'smooth',
    });
}
